import React from 'react';
import {GameDto} from "../../games/types";
import DragonIcon from "../../commons/icons/DragonIcon";
import CardsIcon from "../../commons/icons/CardsIcon";
import DiceIcon from "../../commons/icons/DiceIcon";
import {Card, Empty, Image, Typography} from "antd";
import {smallLauncherCard} from "../common/styles";

export const GameCard: React.FC<{game: GameDto}> = ({game}) => {
    const _game = game as GameDto;
    const icon: React.ReactElement =
        _game.type.tag === 'ttrpgs' ? <DragonIcon /> :
            _game.type.tag === 'card-games' ? <CardsIcon /> :
                _game.type.tag === 'board-games' ? <DiceIcon /> :
                    <></>;
    return (
        <Card style={{...smallLauncherCard}} title={
            <>
                {icon}
                <Typography.Text underline strong style={{fontSize: '1em', marginLeft: '0.5em'}} >{_game.title}</Typography.Text>
            </>

        } >
            {_game.mediaUrl ? <Image src={_game.mediaUrl} preview={false} /> : <Empty/>}
        </Card>
    )
}